import { render, staticRenderFns } from "./adb-switch.vue?vue&type=template&id=0dd888b6&scoped=true&"
import script from "./adb-switch.vue?vue&type=script&lang=ts&"
export * from "./adb-switch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd888b6",
  null
  
)

export default component.exports